// extracted by mini-css-extract-plugin
export default {"input":"style_input__PizsN"};